var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductCheckoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 56.875C45.9619 56.875 56.875 45.9619 56.875 32.5C56.875 19.0381 45.9619 8.125 32.5 8.125C19.0381 8.125 8.125 19.0381 8.125 32.5C8.125 45.9619 19.0381 56.875 32.5 56.875Z",
    stroke: "#664D03",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3438 40.625H42.6562",
    stroke: "#664D03",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3594 30.4688C25.0421 30.4688 26.4062 29.1046 26.4062 27.4219C26.4062 25.7391 25.0421 24.375 23.3594 24.375C21.6766 24.375 20.3125 25.7391 20.3125 27.4219C20.3125 29.1046 21.6766 30.4688 23.3594 30.4688Z",
    fill: "#664D03"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6406 30.4688C43.3234 30.4688 44.6875 29.1046 44.6875 27.4219C44.6875 25.7391 43.3234 24.375 41.6406 24.375C39.9579 24.375 38.5938 25.7391 38.5938 27.4219C38.5938 29.1046 39.9579 30.4688 41.6406 30.4688Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCheckoutIcon);
export default __webpack_public_path__ + "static/media/ProductCheckoutIcon.c7d578842575a71acee9cfefc440e7f7.svg";
export { ForwardRef as ReactComponent };